const isTruthyPermission = (value) =>
  value === true || value === 'true' || value === 1 || value === '1';

const canCreateAssistant = (userData = {}) => {
  if (!userData || typeof userData !== 'object') return false;

  const rawPermission = userData.permiteCrearAsistente
    ?? userData.PermiteCrearAsistente
    ?? userData.pertmiteCrearAsistente
    ?? userData.PertmiteCrearAsistente;

  return isTruthyPermission(rawPermission);
};

const normalizeAssistantPermissions = (userData = {}) => {
  const assistantPermission = canCreateAssistant(userData);

  return {
    ...userData,
    permiteCrearAsistente: assistantPermission,
    pertmiteCrearAsistente: assistantPermission,
  };
};

export { canCreateAssistant, normalizeAssistantPermissions };
